import { PHASE_COLORS, PRIMARY, RISK_LEVEL_COLORS } from "@app/theme/tokens";
import { Chip } from "@mui/material";
import { PendingValue } from "./PendingValue";

function tinted(color: string) {
  return {
    color,
    bgcolor: `${color}1A`,
    border: `1px solid ${color}55`,
    fontWeight: 600,
  };
}

export function RiskChip({ level }: { level: string | null }) {
  if (!level) {
    return <PendingValue />;
  }
  return (
    <Chip size="small" label={level} sx={tinted(RISK_LEVEL_COLORS[level])} />
  );
}

/** "Implementation Complexity" of a mitigation, read as when it can be delivered. */
export function TimelineChip({ phase }: { phase: string | null }) {
  if (!phase) {
    return <PendingValue />;
  }
  return (
    <Chip
      size="small"
      label={phase}
      sx={tinted(PHASE_COLORS[phase.trim().toLowerCase()] ?? PRIMARY)}
    />
  );
}
